export class SurveyAntiFraud {
  constructor() {
    this.startedAt = null
  }

  recordStart() {
    this.startedAt = new Date().toISOString()
  }

  getStartedAt() {
    return this.startedAt
  }

  getFingerprint() {
    const components = [
      screen.width,
      screen.height,
      screen.colorDepth,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      navigator.language,
      navigator.hardwareConcurrency || 0,
      navigator.userAgent
    ]

    return this.simpleHash(components.join("|"))
  }

  simpleHash(str) {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i)
      hash = ((hash << 5) - hash) + char
      hash = hash & hash // Convert to 32-bit int
    }
    return Math.abs(hash).toString(36)
  }
}
